module.exports = __webpack_public_path__ + "static/media/vtex36.a2fb0e0b.png";